import { createSelector } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.organizations[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectOrganizations = (state) => state.organizations?.organizations;
export const selectOrganizationsLoading = isLoadingSelector('organizationsStatus');

// Filter out licensee and sort by type (insurance, housing_company, service_provider), then alphabetically
const TYPE_ORDER = {
  insurance: 0,
  insurance_broker: 1,
  housing_company: 2,
  service_provider: 3
};

export const selectOrganizationsForOnboarding = createSelector(selectOrganizations, (organizations) => {
  if (!organizations) return [];

  return organizations
    .filter((org) => org.type !== 'licensee')
    .slice()
    .sort((a, b) => {
      const typeA = TYPE_ORDER[a.type] ?? 999;
      const typeB = TYPE_ORDER[b.type] ?? 999;

      if (typeA !== typeB) {
        return typeA - typeB;
      }

      return (a.name || '').localeCompare(b.name || '', 'de');
    });
});

export const selectSelectedOrganizationId = (state) => state.organizations?.selectedOrganizationId;
export const selectSelectedOrganization = (state) => {
  const selectedId = selectSelectedOrganizationId(state);
  const organizations = selectOrganizations(state);

  if (!selectedId || !organizations) return null;

  return organizations.find((org) => org.id === selectedId) || null;
};

export const selectInsuranceOrganizationLogos = (state) => state.organizations?.insuranceOrganizationLogos;

export const selectCreateOrganizationLoading = isLoadingSelector('createOrganizationStatus');
export const selectUpdateOrganizationLoading = isLoadingSelector('updateOrganizationStatus');
export const selectBulkEditOrganizationsLoading = isLoadingSelector('bulkEditOrganizationsStatus');
